import { ApiClient } from '@unitedtraders/utcom-api-sdk';

export const initApi = url => {
  return new ApiClient(url);
};



// WEBPACK FOOTER //
// ./src/services/api.js